/**
 * Lectura de códigos (lector USB/Bluetooth o tipeo + Enter).
 *
 * Los lectores se comportan como un teclado: escriben el código y mandan Enter.
 * El backend busca primero por código de barras exacto y después por SKU.
 */

import { ApiError, api } from "@/lib/api.ts";
import type { ProductOut } from "@/types/api.ts";

/** Producto con ese código de barras o SKU, o null si no existe. */
export async function lookupProduct(code: string): Promise<ProductOut | null> {
  const trimmed = code.trim();
  if (!trimmed) return null;
  try {
    return await api.get<ProductOut>("/products/lookup", { searchParams: { code: trimmed } });
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
